export default {
    id: "17f0a395-09fc-4cad-850c-fd3031f0887d",
    icon: "mdi-table",
    name: "table",
    title: "Table",
    description: "A block table",
}